import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function GraficoEconomicidade({ projeto }) {
  if (!projeto) return <div>Carregando dados...</div>;

  // Busca os valores
  const valorEstimado = parseFloat(projeto.valor_total_projeto) || 0;
  const valorLicitado = parseFloat(projeto.valor_licitado) || 0;

  // Se o valor licitado for 0 ou nulo, ainda não houve licitação para calcular a economia
  if (valorLicitado <= 0) {
    return (
      <div className="alert alert-light text-center border">
        O valor licitado ainda não foi preenchido. Não é possível calcular a
        economicidade.
      </div>
    );
  }

  // NOVA LÓGICA: Calcula a diferença real
  const diferenca = valorEstimado - valorLicitado;
  const isEconomia = diferenca >= 0; // True se sobrou dinheiro, False se faltou
  const valorDiferencaAbsoluto = Math.abs(diferenca);

  // Calcula o percentual em relação ao valor estimado
  const percentual =
    valorEstimado > 0
      ? ((valorDiferencaAbsoluto / valorEstimado) * 100).toFixed(2)
      : 0;

  const data = {
    labels: ["Análise de Economicidade"],
    datasets: [
      {
        label: "Orçamento Estimado",
        data: [valorEstimado],
        backgroundColor: "rgba(149, 165, 166, 0.5)", // Cinza (Referência)
        borderColor: "rgba(149, 165, 166, 1)",
        borderWidth: 1,
      },
      {
        label: "Valor Licitado (Contratado)",
        data: [valorLicitado],
        backgroundColor: "rgba(52, 152, 219, 0.7)", // Azul
        borderColor: "rgba(52, 152, 219, 1)",
        borderWidth: 1,
      },
      {
        // Dinâmico: Muda o título e a cor dependendo se economizou ou gastou mais
        label: isEconomia
          ? `Economia Gerada (${percentual}%)`
          : `Investimento Adicional (${percentual}%)`,
        data: [valorDiferencaAbsoluto],
        backgroundColor: isEconomia
          ? "rgba(46, 204, 113, 0.8)" // Verde (Sucesso/Economia)
          : "rgba(231, 76, 60, 0.8)", // Vermelho (Prejuízo/Custo Extra)
        borderColor: isEconomia
          ? "rgba(46, 204, 113, 1)"
          : "rgba(231, 76, 60, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: { family: "'Poppins', sans-serif", size: 13 },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: R$ ${context.raw.toLocaleString(
              "pt-BR",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              },
            )}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            // Formata o eixo Y para não ficar um número gigante, ex: 1.000.000 -> 1M
            if (value >= 1000000)
              return "R$ " + (value / 1000000).toFixed(1) + "M";
            if (value >= 1000) return "R$ " + (value / 1000).toFixed(1) + "k";
            return "R$ " + value;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: "350px", width: "100%", padding: "10px" }}>
      <Bar data={data} options={options} />
      <div className="text-center mt-3">
        {diferenca > 0 ? (
          <h6 className="text-success">
            <i className="fas fa-arrow-down me-1"></i>
            Economia de {percentual}% (R${" "}
            {valorDiferencaAbsoluto.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
            ) em relação ao valor estimado inicial.
          </h6>
        ) : diferenca < 0 ? (
          <h6 className="text-danger">
            <i className="fas fa-arrow-up me-1"></i>
            Atenção: A licitação fechou com {percentual}% (R${" "}
            {valorDiferencaAbsoluto.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
            ) a mais do que o valor estimado inicial.
          </h6>
        ) : (
          <h6 className="text-muted">
            Licitação fechou exatamente no valor estimado.
          </h6>
        )}
      </div>
    </div>
  );
}

export default GraficoEconomicidade;
